import React, { useEffect } from 'react';

export default function TrustPilotWidget(): JSX.Element | null {
  useEffect(() => {
    // Load TrustPilot script if not already loaded
    const trustPilotScriptId = 'trustpilot-widget-script';
    const existingScript = document.getElementById(trustPilotScriptId);

    if (!existingScript) {
      const script = document.createElement('script');
      script.id = trustPilotScriptId;
      script.src =
        '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      script.async = true;
      script.type = 'text/javascript';

      document.head.appendChild(script);

      return () => {
        const scriptToRemove = document.getElementById(trustPilotScriptId);
        if (scriptToRemove) {
          document.head.removeChild(scriptToRemove);
        }
      };
    }
  }, []);

  return (
    <div className="trustpilot-widget-container">
      <div
        className="trustpilot-widget"
        data-locale="en-GB"
        data-template-id="5419b732fbfb950b10de65e5"
        data-businessunit-id="5b38f65a389fc200016d7bcb"
        data-style-height="24px"
        data-style-width="100%"
        data-token="d3a7ba56-4a64-4ad6-903d-d82aab757557"
      >
        <a
          href="https://uk.trustpilot.com/review/www.kitkeeper.co.uk"
          target="_blank"
          rel="noreferrer"
        >
          Trustpilot
        </a>
      </div>
    </div>
  );
}
